
// This module contains all configuration and constants

(function() {
  'use strict';

  // Ensure Liquid config exists (set by .liquid file)
  const LIQUID = window.PB_LIQUID_CONFIG || {};

  // MAP Collections for loading prices
  window.PB_MAP_COLLECTIONS = [
    { name: 'Promo', handle: 'map-on-promo-items-for-package-builder' },
    { name: 'Ranges', handle: 'map-prices-for-ranges-for-package-builder' },
    { name: 'Rangetops', handle: 'rangetops-map-prices-for-package-builder' },
    { name: 'Range Hoods', handle: 'range-hoods-map-prices-for-package-builder' },
    { name: 'Dishwashers', handle: 'dishwashers-map-prices-for-package-builder' },
    { name: 'Refrigeration', handle: 'full-size-refrigeration-map-prices-for-package-builder' },
    { name: 'Microwaves', handle: 'microwaves-map-prices-for-package-builder' },
    { name: 'Wall Ovens', handle: 'wall-ovens-map-prices-for-package-builder' },
    { name: 'Plumbing', handle: 'plumbing-map-prices-for-package-builder' }
  ];

  // Main configuration
  window.PB_CONFIG = {
    collections: [
      {
        id: 'info-section',
        name: 'Bundle Discount Information',
        type: 'info',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Wall_Ovens.png?v=1666218251'
      },
      {
        id: 'ranges',
        name: 'Ranges',
        handle: LIQUID.collections?.ranges || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Ranges.png?v=1666217738'
      },
      {
        id: 'rangetops',
        name: 'Rangetops',
        handle: LIQUID.collections?.rangetops || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Cooktops.png?v=1666217738'
      },
      {
        id: 'hoods',
        name: 'Range Hoods',
        handle: LIQUID.collections?.hoods || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Range_Hoods.png?v=1666218241'
      },
      {
        id: 'dishwashers',
        name: 'Dishwashers',
        handle: LIQUID.collections?.dishwashers || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Dishwasher.png?v=1666218312'
      },
      {
        id: 'refrigerators',
        name: 'Full-Size Refrigeration',
        handle: LIQUID.collections?.refrigerators || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Refrigeration.png?v=1666217756'
      },
      {
        id: 'column-refrigerators',
        name: 'Column Refrigeration',
        handle: LIQUID.collections?.columnRefrigerators || '',
        icon: '//zlinedealer.com/cdn/shop/files/ZLINE-Dealers-Refrigeration-Icons-No-Text-02_41630c99-7c71-4987-a838-409d6adde572.png?v=1666221642'
      },
      {
        id: 'under-counter-refrigeration',
        name: 'Under Counter Refrigeration',
        handle: LIQUID.collections?.underCounterRefrigeration || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons--No--text_Wine_Cooler.png?v=1666217756'
      },
      {
        id: 'microwaves',
        name: 'Microwaves',
        handle: LIQUID.collections?.microwaves || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Microwaves.png?v=1666218397'
      },
      {
        id: 'wall-ovens',
        name: 'Wall Ovens',
        handle: LIQUID.collections?.wallOvens || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Wall_Ovens.png?v=1666218251'
      },
      {
        id: 'plumbing',
        name: 'Plumbing',
        handle: LIQUID.collections?.plumbing || '',
        icon: '//zlinedealer.com/cdn/shop/files/Home-Page-Icons-No-Text_Bathroom_PLumbing.png?v=1666218529'
      },
      {
        id: 'promo-2',
        name: 'Promo 2',
        handle: LIQUID.collections?.promo2 || '',
        icon: '',
        hidden: true
      }
    ],
     excludedFromDiscount: [
      'Bath and Shower',
      'Kitchen Faucets',
      'Sinks',
      'Bathroom Plumbing',
      'Kitchen Plumbing',
      'Plumbing',
      'Kitchen Faucet',
      'Kitchen Sink',
      'Pot Filler',
      'Bathroom Faucet',
      'Shower System',
      'Tub Filler'
    ]
  };

  // Discount tiers configuration
  window.PB_DISCOUNT_TIERS = [
    { minItems: 2, discount: 0.00, label: 'No discount' },
    { minItems: 3, discount: 0.05, label: '5% discount' },
    { minItems: 4, discount: 0.08, label: '8% discount' },
    { minItems: 6, discount: 0.12, label: '12% discount' }
  ];

  // Get discount percent based on item count
  window.PB_getDiscountPercent = function(itemCount) {
    if (itemCount >= 6) return 0.12;
    if (itemCount >= 4) return 0.08;
    if (itemCount >= 3) return 0.05;
    if (itemCount >= 2) return 0.00;
    return 0;
  };

  // Under counter refrigeration tags
  window.PB_UNDER_COUNTER_TAGS = [
    'Wine Refrigeration',
    'Beverage Fridge',
    'Refrigerator Drawer',
    'Ice Maker'
  ];

  // Helper: Simple hash function
  if (!String.prototype.hashCode) {
    String.prototype.hashCode = function() {
      return this.split('').reduce((h, c) => ((h << 5) - h) + c.charCodeAt(0), 0);
    };
  }

  console.log('Package Builder Config loaded');
})();
